import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelSelect as _vModelSelect, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "frequencies-container"
}
const _hoisted_2 = {
  key: 0,
  class: "frequency-buttons"
}
const _hoisted_3 = ["disabled", "aria-label", "onClick"]
const _hoisted_4 = {
  key: 0,
  class: "frequency-tabs"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id", "checked"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["disabled", "id", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "rd-flex rd-mr-2.5"
}
const _hoisted_10 = {
  key: 0,
  class: "rd-flex rd-mr-2.5 rd-relative"
}
const _hoisted_11 = {
  width: "51",
  height: "52",
  class: "rd-block sm-max:rd-hidden",
  "aria-hidden": "true",
  viewBox: "0 0 51 52",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  for: "setRecurring",
  class: "rd-text-sm rd-mb-0 rd-ml-2.5"
}
const _hoisted_14 = {
  key: 4,
  class: "frequency-options-container"
}
const _hoisted_15 = {
  key: 0,
  class: "relative"
}
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "relative"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FrequencyWarningSnippet = _resolveComponent("FrequencyWarningSnippet")!
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.availableFrequencyOptions.length > 1)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          (_ctx.component.customData.displayType === _ctx.FrequencyDisplayType.Buttons)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.availableFrequencyOptions.length > 1)
                  ? (_openBlock(), _createElementBlock("ul", {
                      key: 0,
                      class: _normalizeClass(["layout-row-cols rd-gap-y-2 -rd-mx-1", _ctx.setFrequencyLayout])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableFrequencyOptions, (frequency) => {
                        return (_openBlock(), _createElementBlock("li", { key: frequency }, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["rd-btn rd-btn-primary rd-w-full", [
                                { active: _ctx.renderStore.gift.frequency === frequency },
                                _ctx.component.customData.buttonSize
                            ]]),
                            style: _normalizeStyle({
                                borderRadius: _ctx.component.styles.borderRadius + 'px !important' || '',
                                borderWidth: _ctx.component.styles.outlineWeight + 'px !important' || '',
                                borderColor: _ctx.component.styles.outlineColor + ' !important' || '',
                                '--button-text-color': _ctx.component.styles.fontColor || '',
                                '--button-hover-color': _ctx.component.styles.hoverColor || '',
                                '--button-hover-text-color': _ctx.component.styles.hoverTextColor || '',
                                '--button-color': _ctx.component.styles.backgroundColor || '',
                            }),
                            type: "button",
                            disabled: _ctx.isFrequencyDisabled,
                            "aria-label": `Choose ${_ctx.frequencyDisplayName(frequency)} frequency for your gift`,
                            onClick: ($event: any) => (_ctx.selectFrequency(frequency))
                          }, _toDisplayString(_ctx.frequencyDisplayName(frequency)), 15, _hoisted_3)
                        ]))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.component.customData.displayType === _ctx.FrequencyDisplayType.Tabs)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.availableFrequencyOptions.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("ul", {
                        class: _normalizeClass(["layout-row rd-mx-0", { 'tabs-underline': _ctx.fieldStyle == _ctx.FieldStyle.Underline }]),
                        style: _normalizeStyle({
                    borderRadius: (_ctx.fieldStyle !== _ctx.FieldStyle.Underline && _ctx.component.styles.borderRadius) && _ctx.component.styles.borderRadius + 'px' || '',
                    '--tab-inactive-bg': _ctx.component.styles.backgroundColor || '',
                    '--tab-inactive-outline': _ctx.component.styles.outlineColor || '',
                })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableFrequencyOptions.slice(0, 2), (frequency) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: frequency,
                            id: frequency === _ctx.Frequency.OneTime ? 'liOneTime' : 'liRecurring',
                            class: _normalizeClass(["rd-flex-0-auto rd-w-1/2", { active: _ctx.getActiveFrequencyTab(frequency) }])
                          }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("input", {
                                id: frequency === _ctx.Frequency.OneTime ? 'freqOneTime' : 'freqRecurring',
                                type: "radio",
                                name: "frequencies",
                                class: "rd-hidden",
                                "aria-hidden": "true",
                                checked: _ctx.getActiveFrequencyTab(frequency)
                              }, null, 8, _hoisted_6),
                              _createElementVNode("label", {
                                class: "rd-hidden",
                                for: frequency === _ctx.Frequency.OneTime ? 'freqOneTime' : 'freqRecurring'
                              }, _toDisplayString(frequency === _ctx.Frequency.OneTime ? 'Give Once' : _ctx.getFrequencyTabText), 9, _hoisted_7)
                            ]),
                            _createElementVNode("button", {
                              class: _normalizeClass(["rd-btn rd-btn-primary rd-w-full", [
                            { active: _ctx.getActiveFrequencyTab(frequency) },
                            _ctx.component.customData.buttonSize,
                            frequency === _ctx.Frequency.OneTime ? 'rd-btn-one-time' : 'rd-btn-recurring'
                        ]]),
                              style: _normalizeStyle({
                            '--tab-outline-radius': _ctx.component.styles.borderRadius && _ctx.component.styles.borderRadius + 'px' || '',
                            '--tab-outline-width': _ctx.component.styles.outlineWeight && _ctx.component.styles.outlineWeight + 'px' || '',
                            '--tab-inactive-text': _ctx.component.styles.fontColor || '',
                            '--tab-active-text': _ctx.component.styles.hoverTextColor || '',
                            '--tab-active-bg': _ctx.component.styles.hoverColor || '',
                            '--tab-active-outline': _ctx.component.styles.activeOutlineColor || '',
                        }),
                              type: "button",
                              disabled: _ctx.isFrequencyDisabled,
                              id: frequency === _ctx.Frequency.OneTime ? 'btnOneTime' : 'btnRecurring',
                              onClick: ($event: any) => (_ctx.selectFrequency(frequency))
                            }, [
                              (frequency === _ctx.Frequency.OneTime)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.component.customData.showIcons)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _cache[4] || (_cache[4] = [
                                          _createElementVNode("svg", {
                                            width: "52",
                                            height: "38",
                                            class: "rd-block sm-max:rd-hidden",
                                            "aria-hidden": "true",
                                            viewBox: "0 0 52 38",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                          }, [
                                            _createElementVNode("path", {
                                              d: "M40.5667 26.3509C40.3722 26.3023 40.1758 26.2614 39.9774 26.2284C39.538 26.1545 39.0849 26.1175 38.6357 26.1175C38.1398 26.1175 37.6381 26.1642 37.1461 26.2536L28.8737 27.7802C28.652 27.6227 28.4342 27.4651 28.2203 27.3076C29.0545 27.0529 29.8382 26.6698 30.5558 26.1603C31.3414 25.6022 32.0162 24.9177 32.5626 24.1224L32.6812 23.9493C33.1849 23.2201 33.3716 22.343 33.2121 21.4777C33.0507 20.6123 32.5626 19.8598 31.8353 19.36L24.4264 14.2593C23.9033 13.8995 23.3471 13.5748 22.7734 13.2967C21.0155 12.4411 19.1448 12.0074 17.2099 12.0074C17.031 12.0074 16.8521 12.0113 16.6713 12.0191C16.2901 10.4323 16.2979 9.38413 16.3096 9.10994C16.3096 9.08077 16.3057 9.05355 16.3057 9.02438C16.3057 4.0695 20.4341 0.0499878 25.529 0.0499878C29.1265 0.0499878 32.2359 3.35777 33.7566 6.28247C35.2773 3.35777 38.3848 0.0499878 41.9823 0.0499878C47.0772 0.0499878 51.2076 4.0695 51.2076 9.02438C51.2076 9.02438 51.9388 17.3765 40.5667 26.3509Z",
                                              fill: "currentColor"
                                            }),
                                            _createElementVNode("path", {
                                              d: "M44.2383 33.9643C44.0925 34.1762 43.8727 34.3182 43.6199 34.3649L25.2453 37.7563C24.8544 37.8282 24.4596 37.8632 24.0629 37.8632C22.7328 37.8632 21.4124 37.4607 20.3079 36.7023L14.2757 32.5486C13.8654 32.2666 13.4337 32.0138 12.9903 31.798C12.6461 31.6288 12.2922 31.481 11.9325 31.3546C11.3899 31.1621 10.8337 31.0182 10.2679 30.9229C10.1745 30.9073 10.0792 30.8918 9.98395 30.8782C9.79532 30.8509 9.60669 30.8296 9.41612 30.814C9.13026 30.7887 8.84246 30.7771 8.55466 30.7771C7.94794 30.7771 7.34316 30.8315 6.74617 30.9423L3.38782 31.5607L0.739258 17.2056L15.3044 14.5181C15.3841 14.5026 15.4639 14.489 15.5436 14.4773C16.1639 14.3762 16.7881 14.3334 17.4065 14.3451C18.3186 14.3626 19.2209 14.5006 20.0979 14.7554C20.2846 14.8098 20.4712 14.8701 20.6579 14.9362C20.7279 14.9615 20.796 14.9868 20.866 15.0121C21.0721 15.0918 21.2783 15.1774 21.4824 15.2688C21.5738 15.3096 21.6633 15.3524 21.7527 15.3952C22.2214 15.6227 22.6764 15.8871 23.1043 16.1827L30.5171 21.2854C30.7291 21.4312 30.871 21.649 30.9177 21.9018C30.9644 22.1546 30.908 22.4094 30.7621 22.6213L30.6396 22.8002C30.2488 23.37 29.7665 23.8601 29.2045 24.2568C28.5006 24.7565 27.7091 25.0832 26.8885 25.233C26.5345 25.2991 26.1748 25.3321 25.817 25.3321C25.7859 25.3321 25.7567 25.3321 25.7256 25.3302C24.5938 25.3146 23.466 24.9724 22.4956 24.3034L19.9676 22.563C19.6467 22.3433 19.2734 22.2266 18.8922 22.2266C18.7755 22.2266 18.6589 22.2383 18.5422 22.2596L17.426 22.4658C16.8543 22.5708 16.5665 23.0064 16.4867 23.3797C16.407 23.7531 16.4926 24.2684 16.9709 24.599L25.043 30.1548C25.4378 30.427 25.9123 30.5729 26.3906 30.5729C26.5326 30.5729 26.6746 30.5593 26.8146 30.534L31.6664 29.6375L37.5352 28.5544L37.5702 28.5485C37.6577 28.533 37.7472 28.5174 37.8366 28.5057C38.0136 28.4824 38.1906 28.4649 38.3675 28.4571C38.457 28.4532 38.5464 28.4513 38.6359 28.4513H38.6398C38.7934 28.4513 38.947 28.4571 39.1006 28.4707C39.2659 28.4844 39.4312 28.5038 39.5946 28.531C41.1094 28.7838 42.494 29.6453 43.3924 30.8937C43.8961 31.5977 44.2325 32.3891 44.3919 33.2448C44.4386 33.4976 44.3842 33.7543 44.2383 33.9643Z",
                                              fill: "currentColor"
                                            })
                                          ], -1)
                                        ])))
                                      : _createCommentVNode("", true),
                                    _cache[5] || (_cache[5] = _createTextVNode(" Give Once "))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (_ctx.component.customData.showIcons)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                          (_openBlock(), _createElementBlock("svg", _hoisted_11, [
                                            _cache[6] || (_cache[6] = _createElementVNode("g", null, [
                                              _createElementVNode("path", {
                                                d: "M46.0473 14.2251C41.9628 7.06211 34.2564 2.23224 25.4209 2.23224C12.319 2.23224 1.69775 12.8535 1.69775 25.9553",
                                                stroke: "currentColor",
                                                fill: "none",
                                                "stroke-width": "3.03003",
                                                "stroke-miterlimit": "10",
                                                "stroke-linecap": "round"
                                              }),
                                              _createElementVNode("path", {
                                                d: "M47.0403 7.21991V14.9828H39.1279",
                                                stroke: "currentColor",
                                                "stroke-width": "3.03003",
                                                "stroke-miterlimit": "10",
                                                "stroke-linecap": "round"
                                              })
                                            ], -1)),
                                            _createElementVNode("g", null, [
                                              _createElementVNode("path", {
                                                d: "M37.1056 24.5012C37.1056 21.2227 34.3746 18.5643 31.0032 18.5643C28.6236 18.5643 26.5672 19.8915 25.5612 21.8267C24.5553 19.8935 22.4989 18.5643 20.1193 18.5643C16.7499 18.5643 14.0168 21.2227 14.0168 24.5012C14.0168 24.5193 14.0188 24.5375 14.0188 24.5577C13.9885 25.2041 14.0108 31.4622 25.5592 38.0212H25.5673C37.7622 31.0965 37.1036 24.5032 37.1036 24.5032L37.1056 24.5012Z",
                                                class: _normalizeClass(["heart", { 'heartbeat': _ctx.hasRecurringAnimation }]),
                                                fill: "currentColor",
                                                stroke: "currentColor"
                                              }, null, 2)
                                            ]),
                                            _cache[7] || (_cache[7] = _createElementVNode("g", null, [
                                              _createElementVNode("path", {
                                                d: "M49.1478 25.9548C49.1478 39.0567 38.5265 49.6779 25.4247 49.6779C16.4174 49.6779 8.58178 44.6582 4.56396 37.2629",
                                                stroke: "currentColor",
                                                fill: "none",
                                                "stroke-width": "3.03003",
                                                "stroke-miterlimit": "10",
                                                "stroke-linecap": "round"
                                              }),
                                              _createElementVNode("path", {
                                                d: "M2.92334 44.2468V36.4838H10.8358",
                                                stroke: "currentColor",
                                                "stroke-width": "3.03003",
                                                "stroke-miterlimit": "10",
                                                "stroke-linecap": "round"
                                              })
                                            ], -1))
                                          ])),
                                          (_ctx.hasRecurringAnimation)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _cache[8] || (_cache[8] = _createStaticVNode("<svg width=\"51\" height=\"52\" aria-hidden=\"true\" viewBox=\"0 0 51 52\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"rd-block rd-absolute sm-max:rd-hidden floating-hearts-1\"><path d=\"M37.1056 24.5012C37.1056 21.2227 34.3746 18.5643 31.0032 18.5643C28.6236 18.5643 26.5672 19.8915 25.5612 21.8267C24.5553 19.8935 22.4989 18.5643 20.1193 18.5643C16.7499 18.5643 14.0168 21.2227 14.0168 24.5012C14.0168 24.5193 14.0188 24.5375 14.0188 24.5577C13.9885 25.2041 14.0108 31.4622 25.5592 38.0212H25.5673C37.7622 31.0965 37.1036 24.5032 37.1036 24.5032L37.1056 24.5012Z\" fill=\"currentColor\"></path></svg><svg width=\"51\" height=\"52\" aria-hidden=\"true\" viewBox=\"0 0 51 52\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"rd-block rd-absolute sm-max:rd-hidden floating-hearts-2\"><path d=\"M37.1056 24.5012C37.1056 21.2227 34.3746 18.5643 31.0032 18.5643C28.6236 18.5643 26.5672 19.8915 25.5612 21.8267C24.5553 19.8935 22.4989 18.5643 20.1193 18.5643C16.7499 18.5643 14.0168 21.2227 14.0168 24.5012C14.0168 24.5193 14.0188 24.5375 14.0188 24.5577C13.9885 25.2041 14.0108 31.4622 25.5592 38.0212H25.5673C37.7622 31.0965 37.1036 24.5032 37.1036 24.5032L37.1056 24.5012Z\" fill=\"currentColor\"></path></svg><svg width=\"51\" height=\"52\" aria-hidden=\"true\" viewBox=\"0 0 51 52\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"rd-block rd-absolute sm-max:rd-hidden floating-hearts-3\"><path d=\"M37.1056 24.5012C37.1056 21.2227 34.3746 18.5643 31.0032 18.5643C28.6236 18.5643 26.5672 19.8915 25.5612 21.8267C24.5553 19.8935 22.4989 18.5643 20.1193 18.5643C16.7499 18.5643 14.0168 21.2227 14.0168 24.5012C14.0168 24.5193 14.0188 24.5375 14.0188 24.5577C13.9885 25.2041 14.0108 31.4622 25.5592 38.0212H25.5673C37.7622 31.0965 37.1036 24.5032 37.1036 24.5032L37.1056 24.5012Z\" fill=\"currentColor\"></path></svg>", 3))
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.getFrequencyTabText), 1)
                                  ], 64))
                            ], 14, _hoisted_8)
                          ], 10, _hoisted_5))
                        }), 128)),
                        _createElementVNode("li", {
                          class: "slider",
                          role: "none",
                          style: _normalizeStyle({
                        '--tab-outline-radius': (_ctx.fieldStyle !== _ctx.FieldStyle.Underline && _ctx.component.styles.borderRadius) && _ctx.component.styles.borderRadius + 'px' || '',
                        '--tab-outline-width': _ctx.component.styles.outlineWeight && _ctx.component.styles.outlineWeight + 'px' || '',
                        '--tab-active-text': _ctx.component.styles.hoverTextColor || '',
                        '--tab-active-bg': _ctx.component.styles.hoverColor || '',
                        '--tab-active-outline': _ctx.component.styles.activeOutlineColor || '',
                    })
                        }, null, 4)
                      ], 6)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.component.customData.displayType === _ctx.FrequencyDisplayType.Checkbox)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "form-element-wrapper rd-relative",
                style: _normalizeStyle({
                justifyContent: _ctx.component.customData.alignment || ''
            })
              }, [
                _withDirectives(_createElementVNode("input", {
                  id: "setRecurring",
                  type: "checkbox",
                  class: "rd-relative",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.makeRecurring) = $event)),
                  disabled: _ctx.isFrequencyDisabled
                }, null, 8, _hoisted_12), [
                  [_vModelCheckbox, _ctx.makeRecurring]
                ]),
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.component.customData.checkboxText), 1)
              ], 4))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.renderStore.builderMode && _ctx.availableFrequencyOptions.length === 1)
      ? (_openBlock(), _createBlock(_component_FrequencyWarningSnippet, {
          key: 1,
          frequency: _ctx.availableFrequencyOptions[0]
        }, null, 8, ["frequency"]))
      : _createCommentVNode("", true),
    (_ctx.availableFrequencyOptions.length === 1 && _ctx.getRecurringFrequencies.length === 1 && _ctx.renderStore.isRecurring && !_ctx.renderStore.builderMode && _ctx.component.customData.displayType !== _ctx.FrequencyDisplayType.Checkbox)
      ? (_openBlock(), _createBlock(_component_FrequencyWarningSnippet, {
          key: 2,
          frequency: _ctx.getRecurringFrequencies[0],
          class: _normalizeClass([_ctx.component.customData.alignment && _ctx.frequencyWarningClass])
        }, null, 8, ["frequency", "class"]))
      : _createCommentVNode("", true),
    (_ctx.getRecurringFrequencies.length === 1 && _ctx.renderStore.isRecurring && !_ctx.renderStore.builderMode && _ctx.component.customData.displayType === _ctx.FrequencyDisplayType.Checkbox)
      ? (_openBlock(), _createBlock(_component_FrequencyWarningSnippet, {
          key: 3,
          frequency: _ctx.getRecurringFrequencies[0],
          class: _normalizeClass([_ctx.component.customData.alignment && _ctx.frequencyWarningClass])
        }, null, 8, ["frequency", "class"]))
      : _createCommentVNode("", true),
    (_ctx.isRecurringVisible || _ctx.isBuilderRecurringVisible)
      ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-row", [_ctx.frequencyOptionsClasses, { 'md:rd-gap-x-4': _ctx.fieldStyle != _ctx.FieldStyle.Compact }]])
          }, [
            (_ctx.component.customData.displayType !== _ctx.FrequencyDisplayType.Buttons)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.isRecurringDropdownShown && _ctx.getRecurringFrequencies.length > 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["form-field-container rd-w-full", [{ 'md:rd-flex-equal': _ctx.component.customData.canChooseStartDate },
                        { 'form-underline': _ctx.fieldStyle == _ctx.FieldStyle.Underline },
                        { 'form-compact': _ctx.fieldStyle == _ctx.FieldStyle.Compact }]])
                      }, [
                        _cache[12] || (_cache[12] = _createElementVNode("label", { for: "frequencySelection" }, [
                          _createTextVNode("Frequency"),
                          _createElementVNode("span", {
                            class: "req",
                            "aria-hidden": "true"
                          }, "*")
                        ], -1)),
                        (_ctx.fieldStyle == _ctx.FieldStyle.Underline)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _withDirectives(_createElementVNode("select", {
                                id: "frequencySelection",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFrequency) = $event))
                              }, [
                                _cache[9] || (_cache[9] = _createElementVNode("option", {
                                  disabled: "",
                                  value: "0"
                                }, "How often you'd like to contribute", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRecurringFrequencies, (frequency) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: frequency,
                                    value: frequency
                                  }, _toDisplayString(_ctx.frequencyDisplayName(frequency)), 9, _hoisted_16))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.selectedFrequency]
                              ]),
                              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "border-input-focus" }, null, -1))
                            ]))
                          : _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 1,
                              id: "frequencySelection",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedFrequency) = $event))
                            }, [
                              _cache[11] || (_cache[11] = _createElementVNode("option", {
                                disabled: "",
                                value: "0"
                              }, "How often you'd like to contribute", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRecurringFrequencies, (frequency) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: frequency,
                                  value: frequency
                                }, _toDisplayString(_ctx.frequencyDisplayName(frequency)), 9, _hoisted_17))
                              }), 128))
                            ], 512)), [
                              [_vModelSelect, _ctx.selectedFrequency]
                            ])
                      ], 2))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.renderStore.isRecurring && _ctx.component.customData.canChooseStartDate)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(['start-date form-field-container rd-w-full', { 'md:rd-flex-equal': _ctx.isRecurringDropdownShown }, _ctx.formFieldContainerClass, _ctx.startDateContainerClasses])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['label', _ctx.labelClass])
                  }, _cache[13] || (_cache[13] = [
                    _createTextVNode("Start Date"),
                    _createElementVNode("span", {
                      class: "req",
                      "aria-hidden": "true"
                    }, "*", -1)
                  ]), 2),
                  _createVNode(_component_Datepicker, {
                    modelValue: _ctx.renderStore.gift.startDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.renderStore.gift.startDate) = $event)),
                    utc: "",
                    id: "startDate",
                    "min-date": _ctx.minDate,
                    "max-date": _ctx.maxDate,
                    "text-input": _ctx.datePickerTextInput,
                    "auto-apply": true,
                    "enable-time-picker": false,
                    position: "left",
                    placeholder: "Date for the first gift"
                  }, null, 8, ["modelValue", "min-date", "max-date", "text-input"]),
                  (_ctx.fieldStyle === _ctx.FieldStyle.Underline)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[14] || (_cache[14] = [
                        _createElementVNode("span", { class: "border-input-focus" }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}